function saveStateToLocalStorage(state) {
  if(state != null) {
    try {
      localStorage.setItem('state', JSON.stringify(state));
    } catch (e) {
      console.error('Failed to save state: ', e);
    }
  } else {
    localStorage.removeItem('state');
  }
}

export function loadStateFromLocalStorage() {
  try {
    return JSON.parse(localStorage.getItem('state'));
  } catch (e) {
    console.error('Failed to load state: ', e);
    return null;
  }
}

export function dumpState() {
  return (dispatch, getState) => {
    let state = getState();
    saveStateToLocalStorage(state);
  }
}

export const RESTORE_STATE = 'RESTORE_STATE';
export const restoreState = payload => ({type: RESTORE_STATE, payload})


// WEBPACK FOOTER //
// ./src/actions/localStorage.js